import Router from "@/router";
const state = {
  step: 1
}
const mutations = {
  setStep(state, payload) {
    state.step = payload
  }
}
const actions = {
  setStep({ commit }, payload) {
    if (payload < 1) return
    if (payload > 7) return
    commit('setStep', payload)
  },
  clearData({ dispatch }, payload) {
    console.log("clearData")
    dispatch('fengxian/clearData', null, { root: true });
    dispatch('qiangzhi/clearData', null, { root: true });
    dispatch('insuranceSelect/insuranceSelectClear', null, { root: true });
    dispatch('ElectronicDocumentsAdd/clearData', null, { root: true });
    if(!payload){
      return
    }
    if (payload.type == 'toStep1') {
      dispatch("setStep", 1);
      return
    }
     if (payload.type == 'toHome') {
      Router.replace("/home")
      dispatch("setStep", 1);
      return
    }
    if(payload.type == 'toStep7'){
      dispatch("setStep", 7);
      return
    }
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations
}